const Contact = () => {
    return (
        <>
            <h1>Kontakt oss</h1>
            <p>Du kan kontakte oss ved å sende oss en epost...</p>
        </>
    )
}
export default Contact;